import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../client';
import { queryKeys } from '../react-query.config';
import { useAuth } from '@/contexts/AuthContext';

export const useUserDetails = () => {
  const { isAuthenticated } = useAuth();

  return useQuery({
    queryKey: queryKeys.user.details(),
    queryFn: async () => {
      return apiClient.get('/api/auth/user-details');
    },
    // Only fetch when authenticated. Previously ungated + retry:2, so a logged-out
    // SkyPicks user fired this up to 3× (all 401) before the OAuth redirect
    // (DKPLAT-670). DK passes a token so it's authenticated and fetches normally.
    enabled: isAuthenticated,
    staleTime: 1000 * 60 * 5, // 5 minutes
    retry: 2,
  });
};
